// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "index" + "." + "77cbdc36afa31094249c" + ".css";
};